import { useReducer, useEffect } from 'react';

const useData = (url, initialData) => {
    const initialState = {
        isLoaded: false,
        data: initialData || {},
        url: url
    };

    const [state, dispatch] = useReducer((oldState, action) => {
        switch (action.type) {
            case 'loading':
                return { ...oldState, isLoaded: false };
            case 'loaded':
                return { ...oldState, isLoaded: true, data: action.payload };
            case 'setUrl':
                return { ...oldState, isLoaded: false, url: action.payload };
            default:
                return oldState;
        }
    }, initialState);

    useEffect(() => {
        if (initialData === undefined || initialData === null) {
            if (state.url !== undefined && state.url !== null) {
                fetchData();
            }
        } else {
            dispatch({ type: 'loaded', payload: initialData });
        }
    }, [state.url]);

    function fetchData() {
        if (state.isLoaded) {
            dispatch({ type: 'loading' });
        }

        window.fetch(state.url)
            .then((response) => {

                if (response.redirected) {
                    //captures redirect url, replaces query string and forwards browser
                    let redirectUrl = response.url.split('?')[0];
                    redirectUrl += `?returnurl=${window.location.href}`;
                    window.location.href = redirectUrl;
                    return false;
                }

                if (response.ok) {
                    //good result
                    return response.text().then((result) => {
                        if (result && result.length) {
                            try {
                                //check if response is JSON
                                const resultData = JSON.parse(result);
                                dispatch({ type: 'loaded', payload: resultData });
                            }
                            catch (err) {
                                //not JSON, process text
                                console.log(result);
                            }
                        }
                    });
                }

                return response.text().then((text) => { throw text; });
            }).catch((error) => {
                console.log(error);
                dispatch({ type: 'loaded', payload: error });
            });
    };

    function setData(data) {
        dispatch({ type: 'loaded', payload: data });
    }

    function setUrl(newUrl) {
        dispatch({ type: 'setUrl', payload: newUrl });
    }

    return {
        isLoaded: state.isLoaded,
        data: state.data,
        setData: setData,
        fetchData: fetchData,
        setUrl: setUrl
    }
};

export default useData;